import { AreaFilter } from './area-filter';

export class AreaFilterStorage {
    filter: AreaFilter;
    filterValues: Map<string, any>;

    constructor(filter: AreaFilter) {
        this.filter = filter;
        this.filterValues = new Map();
    }
}
